
import { mapGetters } from 'vuex'
import generateHeader from '~/helpers/header'
import RewardsPageFAQ from '~/components/rewards-page/rewards-faq'
import RewardsPageCTAJoinSignIn from '~/components/rewards-page/rewards-cta-join-sign-in'
import RewardsPageEarnPoints from '~/components/rewards-page/rewards-earn-points/rewards-earn-points'
import RewardsPageSteps from '~/components/rewards-page/rewards-steps'
import RewardsPageBanner from '~/components/rewards-page/rewards-banner'
import RewardsPageTable from '~/components/rewards-page/rewards-table'
import RewardsMenu from '~/components/rewards-page/rewards-menu'
import RewardsPoints from '~/components/rewards-page/rewards-points'

export default {
  components: {
    RewardsPageFAQ,
    RewardsPageCTAJoinSignIn,
    RewardsPageEarnPoints,
    RewardsPageSteps,
    RewardsPageBanner,
    RewardsPageTable,
    RewardsMenu,
    RewardsPoints,
  },
  async asyncData({ error, app: { $storyblok, $axios } }) {
    try {
      const { story } = await $storyblok.getStory(`/pages/rewards`)
      return { story: story.content }
    } catch (e) {
      error({
        statusCode: 404,
        message: `[REWARDS PAGE] Error asyncData /pages/rewards.vue : ` + e,
      })
    }
  },
  head() {
    if (!this.story.seo) return
    this.story.seo.og_image = this.story.seo.og_image
      ? this.story.seo.og_image
      : this.$config.DEFAULT_OG_IMAGE

    return generateHeader({
      ...this.story.seo,
      path: this.$route.path,
      isNoIndex: this.story.noIndex,
    })
  },
  computed: {
    ...mapGetters({
      vxCustomer: 'customer/getCustomer',
    }),
  },
  mounted() {
    if (window.location.search.includes('_storyblok')) {
      this.$storybridge(() => {
        const { StoryblokBridge } = window
        const storyblokInstance = new StoryblokBridge()
        // Use the input event for instant update of content
        storyblokInstance.on('input', (event) => {
          if (event.story.id === this.story.id) {
            this.story.content = event.story.content
          }
        })
        // Use the bridge to listen the events
        storyblokInstance.on(['published', 'change'], (event) => {
          // window.location.reload()
          this.$nuxt.$router.go({
            path: this.$nuxt.$router.currentRoute,
            force: true,
          })
        })
      })
    }
  },
}
